import React, { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../data/landing";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section className="bg-paper" data-id="element-52" data-mp="1gdh0hevbom39">
      <div className="mx-auto max-w-3xl px-5 py-16 md:py-20" data-id="element-53" data-mp="1geimufhsgv0a">
        <h2 className="text-center font-display text-2xl font-bold text-ink md:text-3xl" data-id="element-54" data-mp="2e0prfpe3encn">Preguntas frecuentes</h2>

        <div className="mt-10 divide-y divide-line border-y border-line" data-id="element-55" data-mp="292o8d4go2o16">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-56" data-mp="1z3oyjik60mcl" data-mpi={i}>
                <h3 data-id="element-57" data-mp="1z2dtlfezh8jw">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left font-bold text-ink transition-colors duration-150 ease-out hover:text-plum focus:outline-none focus-visible:text-plum" data-id="element-58" data-mp="1z59rj3qtzx8c">
                    {f.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-plum transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-59" data-mp="fiypjskm1q2o" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-60" data-mp="bies0nw4kkg0">
                  {isOpen && <motion.div id={`faq-${i}`} initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={reduce ? undefined : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-61" data-mp="3sz6i00jnyvn1">
                      <p className="pb-5 leading-relaxed text-muted" data-id="element-62" data-mp="1uhmgb1mhpze7">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}